// src/theme/yofukashi.js
import { createTheme } from "@mui/material/styles";

import system from "./system";
import assets from "./assets";
import components from "./components";
import backgroundStyles from "./backgroundStyles";

export const theme = createTheme({
  system: system,
  assets: assets,
  backgroundStyles: backgroundStyles,
  components: components,
  typography: {
    fontFamily: system.fonts.body,
    color: system.colors.text.primary,
    h1: {
      fontFamily: system.fonts.heading,
      fontSize: "20px",
      fontWeight: "bold",
      color: system.colors.text.primary,
    },
    h2: {
      fontFamily: system.fonts.heading,
      fontSize: "28px",
      color: system.colors.text.primary,
    },
    h3: {
      fontFamily: system.fonts.heading,
      fontSize: "22px",
      color: system.colors.text.primary,
    },
    h4: {
      fontFamily: system.fonts.heading,
      fontSize: "20px",
      fontWeight: "bold",
      color: system.colors.text.primary,
    },
    h5: {
      fontFamily: system.fonts.heading,
      fontSize: "18px",
      color: system.colors.text.primary,
    },
    h6: {
      fontFamily: system.fonts.heading,
      fontSize: "16px",
      color: system.colors.text.primary,
      fontWeight: "bold",
    },
    body1: {
      fontFamily: system.fonts.body,
      fontSize: "18px",
      lineHeight: "1.8",
      color: system.colors.text.primary,
    },
    body2: {
      fontFamily: system.fonts.body,
      fontSize: "14px",
      color: system.colors.text.primary,
    },
    sectionHeader: {
      fontFamily: system.fonts.heading,
      fontSize: "36px",
      lineHeight: "1.8",
      fontWeight: "bold",
      color: system.colors.text.primary,
    },
    caption: {
      fontFamily: system.fonts.body,
      fontSize: "12px",
      color: system.colors.text.secondary,
    },
  },
});

export default theme;
